import { FC } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { cn, FaIcon } from '@fe-learner-common';

type AriaProps = {
  [key: `aria-${string}`]: string | boolean | number;
};

export interface CheckboxProps extends AriaProps {
  className?: string;
  onChange: () => void;
  checked: boolean;
  disabled?: boolean;
  id: string;
  size: 'sm' | 'md' | 'lg';
}

export const checkboxSizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export const Checkbox: FC<CheckboxProps> = ({
  checked,
  id,
  onChange,
  size,
  disabled,
  className,
  ...ariaProps
}) => (
  <CheckboxPrimitive.Root
    className={cn(
      'flex appearance-none items-center justify-center rounded border border-neutral-300 bg-neutral-0 hover:border-neutral-400 data-[disabled]:border-neutral-200 data-[state=checked]:border-prominence-500 data-[disabled]:bg-neutral-50 data-[state=checked]:bg-prominence-500 hover:data-[state=checked]:border-prominence-500',
      checkboxSizeMap[size],
      className,
    )}
    onKeyDown={(e) => {
      if (e.key === 'Enter' && !disabled) {
        onChange();
      }
    }}
    checked={checked}
    onClick={(e) => {
      e.stopPropagation();
    }}
    onCheckedChange={onChange}
    id={id}
    disabled={disabled}
    {...ariaProps}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <FaIcon
        width={12}
        height={12}
        className="text-neutral-0"
        icon={faCheck}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
